'use strict';

angular.module('shiftTraderApp')
  .controller('ProfileAvailabilityChangeRequestCtrl', function ($scope, user, positions, me,
                                       userAvailabilityChangeRequest, Session, ServerUrls,
                                       $uibModal, org, UserPermissionsService) {

    $scope.user = user;
    $scope.me = me;
    $scope.org = org;
    $scope.userAvailabilityChangeRequest = userAvailabilityChangeRequest;
    $scope.availabilityChangeRequest = $scope.userAvailabilityChangeRequest.availability_change_request;

    $scope.state = {
      rawPermissions: null,
      derivedPermissions: null
    };

    var permissionsToLookUp = [
      'availability_sets.approve',
      'availability_sets.view_target'
    ];

    function processRawPermissions() {
      $scope.state.derivedPermissions = {
        canApprove: $scope.state.rawPermissions['availability_sets.approve'],
        canViewTarget: $scope.state.rawPermissions['availability_sets.view_target']
      };
    }

    UserPermissionsService.getCanDict(permissionsToLookUp, $scope.org.id)
      .then(function(dikt) {
        $scope.state.rawPermissions = dikt;

        processRawPermissions();
      });

  });
